import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccesosSistemaService {

  constructor(private http: HttpClient) { }

  /**
   * Obtiene los últimos accesos al sistema del usuario logueado
   * El backend filtra automáticamente por el usuario del token JWT
   * @param params Parámetros de filtro (limite, fecha_desde, fecha_hasta)
   */
  getUltimosAccesos(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    
    if (params) {
      if (params.limite) httpParams = httpParams.set('limite', params.limite.toString());
      if (params.fecha_desde) httpParams = httpParams.set('fecha_desde', params.fecha_desde);
      if (params.fecha_hasta) httpParams = httpParams.set('fecha_hasta', params.fecha_hasta);
    }

    return this.http.get(`${environment.baseUrl}admin/accesos/ultimos`, { params: httpParams });
  }

  /**
   * Obtiene estadísticas de accesos del usuario logueado
   * El backend filtra automáticamente por el usuario del token JWT
   * @param params Parámetros de filtro (fecha_desde, fecha_hasta)
   */
  getEstadisticasAccesos(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    
    if (params) {
      if (params.fecha_desde) httpParams = httpParams.set('fecha_desde', params.fecha_desde);
      if (params.fecha_hasta) httpParams = httpParams.set('fecha_hasta', params.fecha_hasta);
    }

    return this.http.get(`${environment.baseUrl}admin/accesos/estadisticas`, { params: httpParams });
  }

  /**
   * Obtiene accesos por usuario específico
   * @param usuario Nombre del usuario
   * @param limite Límite de registros
   */
  getAccesosPorUsuario(usuario: string, limite?: number): Observable<any> {
    let httpParams = new HttpParams();
    
    if (limite) {
      httpParams = httpParams.set('limite', limite.toString());
    }

    return this.http.get(`${environment.baseUrl}admin/accesos/usuario/${usuario}`, { params: httpParams });
  }
}
